import React from "react";
import BadgePoint from "../badgePoint/BadgePoint";

export default function PageTitle({ name, description, points, children }) {
  return (
    <div
      className={"py-2"}
      style={{
        userSelect: "none",
        borderBottom: "1px solid #ccc",
        backgroundColor: "#FFF",
      }}
    >
      <div
        style={{
          fontWeight: "700",
          fontSize: "x-large",
        }}
      >
        {name}
      </div>
      {points ? (
        <div
          style={{
            justifyContent: "center",
            display: "flex",
            marginBottom: 15,
          }}
        >
          <BadgePoint points={points} position="relative" />
        </div>
      ) : null}
      <div
        style={{
          fontWeight: "500",
          fontSize: "large",
        }}
      >
        {description}
      </div>
      <div>{children}</div>
    </div>
  );
}
